import { useEffect } from "react";

import AOS from "aos";

import "./hero.css";
import "aos/dist/aos.css";

export default function Hero() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="hero" id="hero" data-aos="fade-left">
      <div className="hero--bg"></div>
      <div className="hero--container">
        <p className="hero--name">
          Oi, sou <strong>Leandro Salles</strong>
        </p>
        <p className="hero--job">Desenvolvedor Front-end</p>
        <p>Código simples, grande impacto!</p>
      </div>
    </div>
  );
}
